
import * as d3 from "../lib/d3.js";
import {isNumberArray} from "../framework/validate.js";

export const DEFAULT_POINT_RADIUS = 5;

/**
 * @see EarthServer.annotate
 *
 * @param svg D3 selection for the SVG annotation layer
 * @param {string} id unique id for this annotation
 * @param {object|null} feature GeoJSON Feature object, or null to remove
 * @param {object|undefined} projection the D3 projection to use for rendering the annotation, or undefined
 */
export function annotate(svg, id, feature, projection) {

    const existing = svg.select(`#${id}`);
    if (feature === null) {
        existing.remove();
        return;
    }
    const element = d3.select(existing.node() ?? svg.append("path").attr("id", id).node()).datum(feature);

    const styling = feature.properties;
    const clazz = styling.class;
    const fill = d3.color(styling.fill);
    const stroke = d3.color(styling.stroke);
    const {strokeWidth, strokeDasharray} = styling;

    if (clazz) {
        element.attr("class", clazz);
    } else {
        element.attr("class", null);
    }

    if (fill) {
        element.attr("fill", fill.copy({opacity: 1}));
        element.attr("fill-opacity", fill.opacity !== 1 ? fill.opacity : null);
    } else {
        element.attr("fill", null);
        // Because overriding the default SVG fill-opacity of 1 will make it impossible to do fill styling with CSS,
        // just remove the attribute when both fill and stroke are undefined.
        element.attr("fill-opacity", !stroke ? null : 0);
    }

    if (stroke) {
        element.attr("stroke", stroke.copy({opacity: 1}));
        element.attr("stroke-opacity", stroke.opacity !== 1 ? stroke.opacity : null);
        element.attr("stroke-width", strokeWidth ?? 1);
        element.attr("stroke-dasharray", isNumberArray(strokeDasharray) ? strokeDasharray.join(",") : null);
    } else {
        element.attr("stroke", null);
        element.attr("stroke-opacity", null);
        element.attr("stroke-width", null);
        element.attr("stroke-dasharray", null);
    }

    if (projection) {
        // Draw the GeoJSON feature with the current projection.
        const path = d3.geoPath(projection).pointRadius(d => d.properties?.pointRadius ?? DEFAULT_POINT_RADIUS);
        element.attr("d", path);
    }
}
